import { BelongingInput } from "./belonging-input";

export const SubmissionInput = BelongingInput;
